import React from "react";
import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import formatToReal from "../Utils/fomartToReal";
import formatToNumber from "../Utils/formartToNumber";
import stylePDF from "./styles/stylePDF";

const GeneratePDF = ({
  simulacoes = [],
  prazoMeses,
  valorSolicitado,
  valorDoImovel,
}) => (
  <Document>
    <Page size="A4" style={stylePDF.page}>
      <Image
        src={"/assets/inter-pdf.png"}
        style={{ width: 50, height: 50, marginRight: 10 }}
      />
      <View style={stylePDF.row}>
        <Text style={stylePDF.title}>Simulação Teórica</Text>
      </View>
      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Tipo da Operação</Text>
        <Text style={stylePDF.info}>{simulacoes[0].produto}</Text>
      </View>

      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Sistema de amortização</Text>
        <Text style={stylePDF.info}>{simulacoes[0].sistemaAmortizacao}</Text>
      </View>

      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Total CET</Text>
        <Text style={stylePDF.info}>
          {formatToReal(simulacoes[0].totalCet)}
        </Text>
      </View>

      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Total CESH</Text>
        <Text style={stylePDF.info}>
          {formatToReal(simulacoes[0].totalCesh)}
        </Text>
      </View>

      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Valor estimado do imóvel</Text>
        <Text style={stylePDF.info}>{formatToReal(valorDoImovel)}</Text>
      </View>
      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Valor solicitado</Text>
        <Text style={stylePDF.info}>{formatToReal(valorSolicitado)}</Text>
      </View>
      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Valor das despesas</Text>
        <Text style={stylePDF.info}>
          {formatToReal(simulacoes[0].despesas)}
        </Text>
      </View>
      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Valor das despesas registrada</Text>
        <Text style={stylePDF.info}>
          {formatToReal(simulacoes[0].despesasRegistro)}
        </Text>
      </View>

      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Valor do IOF</Text>
        <Text style={stylePDF.info}>
          {formatToReal(simulacoes[0].despesasAvaliacao)}
        </Text>
      </View>

      <View style={stylePDF.row}>
        <Text style={stylePDF.info}>Prazo em meses</Text>
        <Text style={stylePDF.info}>{prazoMeses}</Text>
      </View>

      <View style={stylePDF.table}>
        <View style={[stylePDF.rowTable, stylePDF.header]}>
          <Text style={stylePDF.cell}>N°</Text>
          <Text style={stylePDF.cell}>Amortização (R$)</Text>
          <Text style={stylePDF.cell}>Juros (R$)</Text>
          <Text style={stylePDF.cell}>Total Seguros</Text>
          <Text style={stylePDF.cell}>Valor do Mip</Text>
          <Text style={stylePDF.cell}>Valor do Diff</Text>
        </View>

        {simulacoes.length > 0 &&
          simulacoes[0]?.parcelas?.map((item, index) => (
            <View key={index} style={stylePDF.rowTable}>
              <Text style={stylePDF.cell}>{index + 1 ?? "-"}</Text>
              <Text style={stylePDF.cell}>
                {item?.valorAmortizacao
                  ? item.valorAmortizacao.toFixed(2)
                  : "-"}
              </Text>
              <Text style={stylePDF.cell}>
                {item?.valorJuros
                  ? item.valorJuros.toFixed(2).replace(".", ",")
                  : "-"}
              </Text>
              <Text style={stylePDF.cell}>
                {item?.valorSeguro
                  ? item.valorSeguro.toFixed(2).replace(".", ",")
                  : "-"}
              </Text>
              <Text style={stylePDF.cell}>
                {item?.valorMip
                  ? item.valorMip.toFixed(2).replace(".", ",")
                  : "-"}
              </Text>
              <Text style={stylePDF.cell}>
                {item?.valorDfi
                  ? item.valorDfi.toFixed(2).replace(".", ",")
                  : "-"}
              </Text>
            </View>
          ))}
      </View>
      <Text style={stylePDF.info}>
        A simulação é apenas ilustrativa e pode sofrer alterações. Taxas, prazos
        e aprovação dependem da análise de crédito. As parcelas não incluem
        correções como IPCA ou TR, que atualizam mensalmente o saldo devedor. O
        CET é estimado com base nas condições do momento. Custos de seguros
        podem ser incorporados ao financiamento. Condições podem mudar sem aviso
        prévio.
      </Text>
    </Page>
  </Document>
);
export default GeneratePDF;
